import ConfettiIcon from '@/features/letterParty/assets/images/confetti.svg?react';

import type { CSSProperties } from 'react';

interface GridPosition {
	x: number;
	y: number;
}

interface ConfettiProps {
	position: GridPosition;
	size: number;
	collected?: boolean;
}

const Confetti = ({ position, size, collected }: ConfettiProps) => {
	const sizeClamped = Math.max(20, size * 0.9);
	const offset = (sizeClamped - size) / 2;

	const wrapperStyle: CSSProperties = {
		left: position.x * size - offset,
		top: position.y * size - offset,
		width: sizeClamped,
		height: sizeClamped,
		zIndex: 100 + position.y, // Higher y = higher z-index (bottom confetti appear above)
	};

	if (collected) {
		return null;
	}

	return (
		<div className="letter-party-game__confetti" style={wrapperStyle} data-collected={collected}>
			<ConfettiIcon width={sizeClamped} height={sizeClamped} />
		</div>
	);
};

export default Confetti;
